import React, { Component } from "react";
import ValidBrowser from "../Utils/ValidBrowser";
import { testValidBrowser } from "../Utils/helpers";
import Firebase, { METHODS } from "../Utils/Firebase";
import { snapShotToArray } from "../Utils/helpers";
import NavButton from "../Components/Button/Nav.button.jsx";
import VideoCardList from "../Components/VideoCardList.jsx";
import LoaderModule from "../Components/Loader.jsx";
import DisabledRecordButton from "./Button/DisabledRecordButton";

const style = {
  social: {
    position: "absolute",
    right: "50px",
    marginTop: "13px",
    marginLeft: "20px"
  },
  info: {
    color: "red",
    display: "bloc",
    fontSize: ".7rem"
  },
  link: {
    color: "blue",
    textDecoration: "underline"
  },
  MySpeeches: {
    backgroundColor: "#e0e0e080",
    padding: "10px 0",
    margin: "0",
    h2: {
      fontSize: "2em",
      textTransform: "uppercase",
      textAlign: "left",
      paddingLeft: "20px"
    }
  },
  EvaluableSpeeches: {
    backgroundColor: "rgba(50,0,20,0.1)",
    padding: "10px 0"
  }
};

export default class SpeechesList extends Component {
  handleEditClick = (video) => {
    console.log(video);
  };

  render() {
    const { user } = this.props;
    const userUid = user.uid;
    let myVideos = [];

    return (
      <div>
        <Firebase
          refPath="/videos"
          method={METHODS.ON}
          renderSuccess={(snapshot) => {
            if (!snapshot.val()) {
              myVideos = [];
            }
            else {
              const videos = snapShotToArray(snapshot);
              myVideos = videos.filter((video) => video.userId === userUid);
            }

            return (
              <div className="MySpeeches">
                <div style={style.MySpeeches}>
                  <h2 style={style.MySpeeches.h2}>Mes pitchs</h2>
                  <VideoCardList
                    videos={myVideos}
                    isVideoCardShareable
                    isEvaluationCheckable
                    currentUser={userUid}
                    onEditClick={(video) => this.handleEditClick(video)}
                  />
                  {myVideos.length === 0 && (
                    <div style={style.noSpeech}>
                      <p>Pas encore de pitch à ton actif ...</p>
                      <ValidBrowser
                        test={testValidBrowser}
                        valid={
                          <NavButton
                            label="Enregistrer"
                            href="/record"
                            disabled={false}
                          />
                        }
                        error={
                          <DisabledRecordButton />
                        }
                      />
                    </div>
                  )}
                </div>
              </div>
            );
          }}
          renderError={(error) => {
            return <pre>{JSON.stringify(error)}</pre>;
          }}
          renderPending={() => <LoaderModule />}
        />
      </div>
    );
  }
}
